/*
* Project: LegalPlace assistant
* File: src/components/misc/pure.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';


// require id, uiid, parent, paren_ui, isDuplicate, copy, content
class LpPure extends Component {
  render() {
    return (
      <div
        data-id={this.props.id}
        data-type="texte_brute"
        data-is-duplicate={this.props.isDuplicate}
        data-copy={this.props.copy}
        dangerouslySetInnerHTML={{ __html: this.props.content }}
      />
    );
  }
}

export default LpPure;



// WEBPACK FOOTER //
// ./src/components/misc/pure.js